import styled from "styled-components";

import TypeaheadMenu from "components/Forms/Typeahead/TypeaheadMenu";

const DataTableTypeaheadMenu = styled(TypeaheadMenu)`
  position: absolute;
  width: 100%;
  z-index: 1;
`;

export default DataTableTypeaheadMenu;
